import { useEffect, useState } from "react";

const DARK_HERO = new Set(["/", "/services", "/for-employers", "/for-candidates"]);

export function useScrolled(threshold) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > threshold);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);
  return scrolled;
}

export function useHeaderState(pathname) {
  const scrolled = useScrolled(12);
  const [megaOpen, setMegaOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  useEffect(() => {
    if (!mobileOpen) return;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = previousOverflow; };
  }, [mobileOpen]);
  useEffect(() => {
    setMobileOpen(false);
    setMegaOpen(false);
  }, [pathname]);
  return { scrolled, dark: !scrolled && DARK_HERO.has(pathname), megaOpen, setMegaOpen,
    mobileOpen, toggleMobile: () => setMobileOpen((open) => !open), closeMobile: () => setMobileOpen(false) };
}